import { Injectable } from '@angular/core';
import { GEOLOCATION_TIMEOUT, ILatLon } from '@curbnturf/entities';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { skipWhile, take } from 'rxjs/operators';
import * as LocationActions from './location.actions';
import { LocationState } from './location.reducer';
import * as LocationSelectors from './location.selectors';

@Injectable({
  providedIn: 'root',
})
export class LocationFacade {
  selectedLocation$: Observable<{ center: ILatLon; distance: number } | undefined>;
  currentLocation$: Observable<ILatLon | undefined>;
  currentLocationOnce$: Observable<ILatLon | undefined>;

  constructor(private store: Store<LocationState>) {
    this.selectedLocation$ = this.store.pipe(select(LocationSelectors.getSelectedLocation));
    this.currentLocation$ = this.store.pipe(select(LocationSelectors.getCurrentLocation));
    this.currentLocationOnce$ = this.currentLocation$.pipe(
      skipWhile((location) => !location),
      take(1),
    );
  }

  select(location: { center: ILatLon; distance: number }) {
    this.store.dispatch(LocationActions.selectLocation(location));
  }

  findCurrentLocation(timeout: number = GEOLOCATION_TIMEOUT, highAccuracy: boolean = false) {
    this.store.dispatch(LocationActions.findCurrentLocation({ timeout, highAccuracy }));
  }
}
